import { ADDON_PRODUCT_RECEIVE } from '../Actions/AddonProduct.action';

export const addons = (state = {addons : []}, action) => {
    switch (action.type) {
        case ADDON_PRODUCT_RECEIVE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}